import { marqueeItems } from "@/mocks/home";

const tickerList = [...marqueeItems, ...marqueeItems];

export default function HeatTicker() {
  return (
    <section className="relative z-10 w-full bg-accent-600 text-background-50">
      <div className="mx-auto flex max-w-[1440px] items-stretch">
        <div className="flex shrink-0 items-center gap-2 bg-accent-700 px-4 py-3 md:px-6">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-flashlight-fill"></i>
          </span>
          <span className="whitespace-nowrap text-xs font-bold tracking-wide md:text-sm">实时热度追踪</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center">
            {tickerList.map((item, index) => (
              <div key={`${item.text}-${index}`} className="flex shrink-0 items-center gap-2 px-5 py-3">
                <span className="whitespace-nowrap text-xs text-background-50 md:text-sm">{item.text}</span>
                <span
                  className={`flex items-center gap-0.5 whitespace-nowrap text-xs font-bold ${
                    item.rising ? "text-primary-100" : "text-background-200"
                  }`}
                >
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className={item.rising ? "ri-arrow-up-fill" : "ri-arrow-down-fill"}></i>
                  </span>
                  {item.delta}
                </span>
                <span className="text-background-50/30">·</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}